import angular from 'angular';
import home from './home/home';
import subcontent from './home/subcontent/subcontent'

let componentModule = angular.module('app.components', [
  home,
  subcontent
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js